/**
 * REQ-104: map layer registry. Renee's "toggle layers one at a time or all together" control can
 * loop over MAP_LAYERS; MapQuickControls is the first consumer.
 *
 * kind 'venueFilter': the button is a shortcut for one filter value (same state as the drawer and
 *                     the Venue Criteria rail, so all three always agree).
 * kind 'geojson':     a separate pin layer (Radio). Its file is baked by scripts/bake-radio-stations.cjs.
 */

// Fixed bucket + token (see bake-radio-stations.cjs) so the URL never changes across re-bakes.
export const RADIO_LAYER_URL = 'https://firebasestorage.googleapis.com/v0/b/venue-report-card.firebasestorage.app/o/'
  + `${encodeURIComponent('baked/layers/radio.geojson')}?alt=media&token=layers-baked-v1`;

export const MAP_LAYERS = [
  {
    id: 'video',
    label: 'Video',
    hint: 'Video capable venues: projector or screen, livestream, or recording',
    icon: { set: 'MaterialCommunityIcons', name: 'camcorder' },
    kind: 'venueFilter',
    filter: { group: 'features', value: 'hasVideo' },
  },
  {
    id: 'radio',
    label: 'Radio',
    hint: 'Radio stations: college, community and low-power FM',
    icon: { set: 'MaterialCommunityIcons', name: 'radio-tower' },
    kind: 'geojson',
    url: RADIO_LAYER_URL,
  },
];

export function visibleMapLayers(layers = MAP_LAYERS) {
  return layers.filter((layer) => !layer.hidden);
}

/** Is a venueFilter layer switched on in this filter state? */
export function isFilterLayerActive(layer, filters) {
  if (!layer || layer.kind !== 'venueFilter' || !layer.filter) return false;
  const values = filters?.[layer.filter.group];
  return Array.isArray(values) && values.includes(layer.filter.value);
}

/** Layer ids that are on, for MapQuickControls' activeLayerIds. */
export function activeMapLayerIds(filters, layers = MAP_LAYERS, extraOn = []) {
  return layers
    .filter((layer) => isFilterLayerActive(layer, filters) || extraOn.includes(layer.id))
    .map((layer) => layer.id);
}
